import axios from "axios";
import { getConfig } from '../configService';

export class PaymentService {
    static keycloak = null;

    static get paymentServiceBaseUrl() {
        if((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && getConfig().localhostApi) {
            return "http://localhost:5047/v1";
        }
        return `${getConfig().apiBaseUrl}/payment/v1`;
    }

    static async startTransaction(providerId, clientId, serviceName, length, appointmentTime, redirectUrl, schedulingSlotId) {
        try {
            var response = await axios({
                method: 'post',
                url: `${this.paymentServiceBaseUrl}/Pay/StartTransaction`,
                data: {
                    providerId: providerId,
                    clientId: clientId,
                    serviceName: serviceName,
                    length: length,
                    appointmentTime: appointmentTime,
                    schedulingSlotId: schedulingSlotId
                },
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + PaymentService.keycloak.token
                },
            });
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async completeTransaction(transactionId, paymentType, redirectUrl) {
        try {
            var response = await axios({
                method: 'post',
                url: `${this.paymentServiceBaseUrl}/Pay/transaction/${transactionId}/complete`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + PaymentService.keycloak.token
                },
                data: {
                    redirectUrl: redirectUrl,
                    paymentType: paymentType
                }
            });
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async cancelTransaction(transactionId) {
        try {
            var response = await axios({
                method: 'post',
                url: `${this.paymentServiceBaseUrl}/Pay/transaction/${transactionId}/cancel`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + PaymentService.keycloak.token
                },
            });
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async getTransaction(transactionId) {
        try {
            var response = await axios({
                method: 'get',
                url: `${this.paymentServiceBaseUrl}/Pay/transaction/${transactionId}`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + PaymentService.keycloak.token
                },
            });
            return await response.data;
        } catch (error) {
            console.log(error)
        }
    }

    static async getClientTransactions(clientId) {
        try {
            var response = await axios({
                method: 'get',
                url: `${this.paymentServiceBaseUrl}/Pay/transactions/client/${clientId}`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + PaymentService.keycloak.token
                },
            });
            return await response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}